import React from 'react'
import { defineMessages, injectIntl } from 'react-intl'
import { Input, TextInput } from '../../Input'
import { required, minLength } from '../../../utils/validations'

const messages = defineMessages({
  label: {
    id: 'LastNameInput.LastName',
    defaultMessage: 'Last Name',
    description: 'The label for the last name text input.',
  },
})

export const LastNameInput = injectIntl(({ intl }) => {
  const { formatMessage } = intl
  const validate = (value) => {
    if (!value) return required(value, formatMessage)
    return minLength(value, 2, formatMessage)
  }

  return (
    <Input
      component={TextInput}
      name='lastName'
      label={formatMessage(messages.label)}
      placeholder={formatMessage(messages.label)}
      validate={validate}
      maxLength={56}
      required
    />
  )
})
